import React from "react";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { useLang } from "@/i18n";
import { Reveal } from "@/lib/motion";

export default function Services() {
  const { t } = useLang();
  return (
    <section id="services" data-testid="services-section" className="relative py-28 lg:py-40 bg-[#0d0d0d] border-y border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12">
        {/* Sticky header */}
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-28">
            <Reveal>
              <span className="font-accent text-xs md:text-sm tracking-[0.25em] uppercase text-[#D4AF37]">{t.services.overline}</span>
              <h2 className="mt-6 font-display text-4xl md:text-5xl font-medium tracking-tight text-white leading-tight">
                {t.services.title}
              </h2>
            </Reveal>
          </div>
        </div>

        {/* Chapters */}
        <div className="lg:col-span-8">
          {t.services.items.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.05}>
              <motion.div
                className="group grid grid-cols-[auto,1fr] gap-6 md:gap-10 border-b border-white/10 py-8 md:py-10 cursor-default"
                data-testid={`service-item-${s.n}`}
                whileHover={{ x: 8 }}
                transition={{ type: "spring", stiffness: 300, damping: 30 }}
              >
                <span className="font-accent text-lg md:text-2xl text-zinc-600 group-hover:text-[#D4AF37] transition-colors duration-300 pt-1">
                  {s.n}
                </span>
                <div>
                  <div className="flex items-start justify-between gap-4">
                    <h3 className="font-display text-2xl md:text-3xl text-white group-hover:text-[#D4AF37] transition-colors duration-300">
                      {s.t}
                    </h3>
                    <Plus className="shrink-0 text-zinc-600 group-hover:rotate-90 group-hover:text-[#D4AF37] transition-all duration-500" size={22} />
                  </div>
                  <p className="mt-4 text-base text-zinc-400 leading-relaxed max-w-2xl">{s.d}</p>
                </div>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
